export default __webpack_public_path__ + "static/media/icon-info.dcc488a4.svg";